<div class="notas">
  <small *ngFor="let fonte of foteNota">
    <em>
      <p>{{ fonte.titulo }}:</p>
      <ul class="lista" *ngFor="let conteudo of fonte.conteudos">
        <li>
          <sup>({{ conteudo.numero }})</sup>
          {{ conteudo.descricao }}
        </li>
      </ul>
    </em>
  </small>
</div>
